import { Suspense, useEffect } from "react";
import { useNavigate, useRoutes, type NavigateFunction } from "react-router-dom";
import i18n from "../i18n";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

function RouteLoadingScreen() {
  const isEnglish = i18n.language?.startsWith("en");

  return (
    <div className="min-h-screen bg-[#081321] text-white">
      <div className="mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center px-6 text-center">
        <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-[#C9A84C]/25 bg-[#C9A84C]/10 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#E8D4A0]">
          <i className="ri-passport-line" />
          Aero Passport
        </span>

        <h1 className="mb-2 text-2xl font-bold sm:text-3xl">
          {isEnglish ? "Opening your travel companion" : "Abrindo seu companion de viagem"}
        </h1>
        <p className="max-w-xl text-sm leading-relaxed text-[#DCE8F4] sm:text-base">
          {isEnglish
            ? "Loading the next surface with the trip context you need right now."
            : "Carregando a próxima tela com o contexto da viagem que você precisa agora."}
        </p>

        <div className="mt-6 h-1.5 w-full max-w-sm overflow-hidden rounded-full bg-white/10">
          <div className="h-full w-1/2 animate-pulse rounded-full bg-gradient-to-r from-[#9B7621] to-[#E8D4A0]" />
        </div>
      </div>
    </div>
  );
}

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  }, [navigate]);

  return <Suspense fallback={<RouteLoadingScreen />}>{element}</Suspense>;
}
